export default (theme) => ({
    root: {
        ...theme.typography.body,
        width: 400,
        height: '100%',
        padding: 24,
        boxSizing: 'border-box',
        backgroundColor: theme.colors.background.utility025,
    },
    isFullWidth: {
        width: '100%',
    },
    actionsMain: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
    },
    actionsSub: {},
    actionsCreateView: {
        marginLeft: 32,
        display: 'inline-block',
        color: theme.colors.actionMajor[500],
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        '&:hover': {
            color: theme.colors.actionMajor[600],
        },
    },
    actionsCreateViewDisabled: {
        marginLeft: 32,
        display: 'inline-block',
        color: theme.colors.grey[200],
        cursor: 'default',
    },
    actions: {
        padding: '12px 0px',
    },
    actionsLeft: {
        display: 'flex',
        alignItems: 'center',
    },
    actionsRight: {},
    actionsClose: {
        display: 'block',
        cursor: 'pointer',
    },
    actionsTitle: {
        marginLeft: 8,
    },
    actionsClear: {
        cursor: 'pointer',
        color: theme.colors.actionMajor[500],
        transition: 'all 0.15s ease',
        '&:hover': {
            color: theme.colors.actionMajor[600],
        },
    },
    actionsClearDisabled: {
        cursor: 'default',
        color: theme.colors.grey[200],
        pointerEvents: 'none',
    },
    content: {
        height: '100%',
        overflow: 'auto',
        ...theme.utils.scrollbar,
    },
    filtersWrapper: {
        height: '100%',
        overflowY: 'auto',
        ...theme.utils.scrollbar,
    },
    withHeader: {
        height: 'calc(100% - 68px)',
    },
    withAddButton: {
        height: 'calc(100% - 56px)',
    },
    withHeaderAndAddButton: {
        height: 'calc(100% - 124px)',
    },
    addButton: {
        paddingTop: 24,
    },
    field: {},
    switchFilter: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
    },
    filter: {
        marginBottom: 8,
        '&:last-of-type': {
            marginBottom: 0,
        },
        '& [class*="headerActiveFields"] $labelMultiline > span:first-child': {
            color: theme.colors.textLight.secondary,
            fontWeight: 500,
        },
    },
    filterHeader: {
        '&:hover': {
            '& $iconSection': {
                display: 'inherit',
            },
            '& [class*="titleContainer"] [class*="HoiPoi__Text"]': {
                color: `${theme.colors.actionMinor[500]} !important`,
            },
        },
    },
    filterHeaderOpen: {
        '& $iconSection': {
            display: 'inherit',
        },
        '& $labelMultiline [class*="HoiPoi__Text__subtitle"]': {
            color: theme.colors.utility.textPrimary,
        },
    },
    FiltersButton: {
        '& path': {
            transition: 'fill .2s ease-in-out',
        },
    },
    iconSection: {
        display: 'none',
        marginRight: 8,
        '&:hover': {
            '& path': {
                fill: theme.colors.grey[700],
            },
        },
    },
    iconDrag: {
        display: 'inherit !important',
        margin: '0px 0px 0px 4px',
        cursor: 'grab',
    },
    filterDragging: {
        '& [class*="HoiPoi__Section__header"]': {
            cursor: 'default',
            pointerEvents: 'none',
            opacity: 0.6,
        },
        '& [data-dragging="true"] [class*="HoiPoi__Section__header"]': {
            opacity: 1,
            cursor: 'grabbing',
            pointerEvents: 'auto',
        },
    },
    slider: {
        marginBottom: -18,
    },
    crossFilter: {
        padding: 16,
        '& [data-rbd-drag-handle-draggable-id], & [class*="HoiPoi__Section__icon"]': {
            alignSelf: 'flex-start',
        },
    },
    subFilters: {
        borderTop: `1px solid ${theme.colors.grey[100]}`,
        marginTop: 8,
        padding: 0,
        '& [class*="FiltersContent__filter"]': {
            marginBottom: 0,
        },
        '& [class*="Section__root"]': {
            paddingRight: 0,
        },
    },
    subFiltersActions: {
        paddingTop: 8,
    },
    labelMultiline: {
        color: theme.colors.utility.textSecondary,
        '& [class*="HoiPoi__Text"]': {
            color: 'inherit',
        },
    },
    subFilterHeader: {
        '& [class*="HoiPoi__Text"]': {
            color: theme.colors.utility.textPrimary,
        },
    },
});
